import type { Locale } from "../Locale.js";
import { getPathInLocale } from "./getPathInLocale.js";

export function getProcedureDetailPath(locale: Locale, urlSlug: string): string {
	return getPathInLocale(locale, `/procedury/${urlSlug}`);
}
